import React from 'react';
import { IoCallOutline } from 'react-icons/io5';
import List from './List';
import payments from '../../images/payments.png';
import { BRAND_LOGO as logoFooter, SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from 'config/brand';
import { t } from 'i18n';

const Footer = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-[67px] pb-5">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="px-4">
            <img
              src={logoFooter}
              alt={t('footer.logoAlt')}
              className="mb-3 h-auto max-h-32 w-auto max-w-[min(100%,240px)] object-contain object-left"
              width={240}
              height={80}
              decoding="async"
            />
            <div className="relative flex w-full items-center justify-center border border-neutral-200 py-4 ps-14 pe-5">
              <IoCallOutline className="absolute start-5 top-1/2 -translate-y-1/2 text-3xl leading-none text-accent" />
              <h5 className="text-center text-[13px] font-light text-neutral-600">
                {t('footer.callUs')}
                <br />
                <span className="text-xl font-normal text-neutral-800 transition-colors duration-300 hover:text-accent">
                  <a href={SUPPORT_PHONE_TEL} dir="ltr">{SUPPORT_PHONE_DISPLAY}</a>
                </span>
              </h5>
            </div>
          </div>
          <div className="px-4">
            <List
              title={t('footer.useful')}
              content={[
                { label: t('footer.about'), to: '/about-us' },
                { label: t('footer.services'), to: '/services' },
                { label: t('footer.howToShop'), to: '/how-to-shop' },
                { label: t('footer.faq'), to: '/faq' },
                { label: t('footer.contact'), to: '/contact-us' },
              ]}
            />
          </div>
          <div className="px-4">
            <List
              title={t('footer.customerService')}
              content={[
                { label: t('footer.paymentMethods'), to: '/payment-methods' },
                { label: t('footer.moneyBack'), to: '/money-back-guarantee' },
                { label: t('footer.returns'), to: '/returns' },
                { label: t('footer.shipping'), to: '/shipping' },
                { label: t('footer.track'), to: '/track' },
                { label: t('footer.terms'), to: '/terms' },
                { label: t('coinsTerms.navLink'), to: '/coins/terms' },
                { label: t('footer.privacy'), to: '/privacy-policy' },
              ]}
            />
          </div>
          <div className="px-4">
            <List
              title={t('footer.myAccount')}
              content={[
                { label: t('footer.signIn'), to: '/auth/sliding' },
                { label: t('footer.viewCart'), to: '/cart' },
                { label: t('footer.myWishlist'), to: '/wishlist' },
                { label: t('footer.myOrders'), to: '/orders' },
                { label: t('coins.navLink'), to: '/coins' },
                { label: t('footer.help'), to: '/contact-us' },
              ]}
            />
          </div>
        </div>
        <hr className="border-neutral-200" />
      </div>
      <hr className="border-neutral-200" />
      <div className="flex flex-col items-center justify-between gap-4 py-[1.1rem] sm:flex-row">
        <div className="flex flex-col items-center sm:items-start">
          <p className="text-sm font-light text-neutral-600">
            {t('footer.copyright', { year: new Date().getFullYear() })}
          </p>
        </div>
        <img src={payments} alt={t('footer.paymentMethodsAlt')} className="max-h-8 w-auto" />
      </div>
    </div>
  );
};

export default Footer;
